export interface LoginTranslation {
    header: {
        tagline: string;
    };
    form: {
        title: string;
        email: {
            label: string;
            placeholder: string;
        };
        password: {
            label: string;
            placeholder: string;
        };
        forgotPassword: string;
        submit: string;
        submitting: string;
    };
    errors: {
        serviceSetup: string;
        emailNotConfirmed: string;
        invalidCredentials: string;
        loginError: string;
    };
    signup: {
        noAccount: string;
        description: string;
        downloadApp: string;
        platforms: string;
    };
    footer: {
        agreement: string;
        terms: string;
        privacy: string;
        and: string;
    };
}

export const loginTranslations: Record<string, LoginTranslation> = {
    en: {
        header: {
            tagline: 'Global Business Communication Platform',
        },
        form: {
            title: 'Login',
            email: {
                label: 'Email',
                placeholder: 'your@email.com',
            },
            password: {
                label: 'Password',
                placeholder: '••••••••',
            },
            forgotPassword: 'Forgot password?',
            submit: 'Login',
            submitting: 'Logging in...',
        },
        errors: {
            serviceSetup: 'Service is being set up. Please try again later.',
            emailNotConfirmed: 'Email verification required. Please check your email.',
            invalidCredentials: 'Invalid email or password.',
            loginError: 'An error occurred during login. Please try again.',
        },
        signup: {
            noAccount: "Don't have an account?",
            description: 'Download the desktop app to access all AivueBiz features',
            downloadApp: 'Download Desktop App',
            platforms: 'Windows / macOS supported',
        },
        footer: {
            agreement: 'By logging in, you agree to AivueBiz\'s',
            terms: 'Terms of Service',
            privacy: 'Privacy Policy',
            and: 'and',
        },
    },
    ko: {
        header: {
            tagline: '글로벌 비즈니스 커뮤니케이션 플랫폼',
        },
        form: {
            title: '로그인',
            email: {
                label: '이메일',
                placeholder: 'your@email.com',
            },
            password: {
                label: '비밀번호',
                placeholder: '••••••••',
            },
            forgotPassword: '비밀번호를 잊으셨나요?',
            submit: '로그인',
            submitting: '로그인 중...',
        },
        errors: {
            serviceSetup: '서비스 설정 중입니다. 잠시 후 다시 시도해주세요.',
            emailNotConfirmed: '이메일 인증이 필요합니다. 이메일을 확인해주세요.',
            invalidCredentials: '이메일 또는 비밀번호가 올바르지 않습니다.',
            loginError: '로그인 중 오류가 발생했습니다. 다시 시도해주세요.',
        },
        signup: {
            noAccount: '아직 계정이 없으신가요?',
            description: 'AivueBiz의 모든 기능을 이용하려면\n데스크톱 앱을 다운로드하세요',
            downloadApp: '데스크톱 앱 다운로드',
            platforms: 'Windows / macOS 지원',
        },
        footer: {
            agreement: '로그인하면 AivueBiz의',
            terms: '이용약관',
            privacy: '개인정보처리방침',
            and: '및',
        },
    },
};

export const getLoginTranslation = (lang: string): LoginTranslation => {
    return loginTranslations[lang] || loginTranslations['en'];
};

export const detectLanguage = (): string => {
    const savedLang = localStorage.getItem('preferredLanguage');
    if (savedLang) return savedLang;
    
    // Default to English for global users
    return 'en';
};